import { UpdateResolver } from '@urql/exchange-graphcache';

import { ChannelSubscriptionOperationEnum } from '@/types/schema';

import { ChannelFragmentDoc } from '../../fragments/generated/Channel';
import { ChannelsSubscription } from '../generated/Channel';

export function getChannelsUpdater(): UpdateResolver {
  return (result, _args, cache) => {
    const response = result as ChannelsSubscription;
    const channel = response.channels.channel;

    switch (response.channels.operation) {
      case ChannelSubscriptionOperationEnum.ChannelUpdated:
        cache.writeFragment(ChannelFragmentDoc, channel);
        break;
      default:
        return;
    }
  };
}
